// internal-deps
import { ShowCroutonArgs } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export interface GetPriorityOfCurrentVSNewCroutonOptions {
    /** When true (MRO), equal priority falls through to endTimestamp tiebreak. */
    useTimestampTiebreak?: boolean;
}

/**
 * Picks the higher-priority crouton (lower `priority` number wins).
 * With `useTimestampTiebreak`, equal priority prefers the sooner `endTimestamp`.
 * Without it (BAU), equal priority keeps `newCrouton` to match the legacy reduce.
 */
export const getPriorityOfCurrentVSNewCrouton = (
    currentCrouton: ShowCroutonArgs,
    newCrouton: ShowCroutonArgs,
    options: GetPriorityOfCurrentVSNewCroutonOptions = {},
) => {
    const { useTimestampTiebreak = false } = options;

    if (isEmpty(newCrouton)) {
        return currentCrouton;
    }
    if (isEmpty(currentCrouton)) {
        return newCrouton;
    }

    if (currentCrouton.priority !== newCrouton.priority) {
        return currentCrouton.priority < newCrouton.priority ? currentCrouton : newCrouton;
    }

    if (!useTimestampTiebreak) {
        return newCrouton;
    }

    const currentCroutonEndTs = currentCrouton?.content?.endTimestamp;
    const newCroutonEndTs = newCrouton?.content?.endTimestamp;

    if (isEmpty(newCroutonEndTs)) return currentCrouton;
    if (isEmpty(currentCroutonEndTs)) return newCrouton;

    return currentCroutonEndTs <= newCroutonEndTs ? currentCrouton : newCrouton;
};
